// extracted by mini-css-extract-plugin
export var searchHeader = "_87-0";
export var searchHeaderDark = "_87-1";